import { render } from "./PlanillaDetAct.vue?vue&type=template&id=4b13fafe&scoped=true"
import script from "./PlanillaDetAct.vue?vue&type=script&lang=js"
export * from "./PlanillaDetAct.vue?vue&type=script&lang=js"

import "./PlanillaDetAct.vue?vue&type=style&index=0&id=4b13fafe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b13fafe"]])

export default __exports__